import { AbstractDataProviderV2 } from 'components/system';
import { CustomerBusinessPlatformUpdate, RsCustomerBusinessPlatformInfo } from './types';

export class CustomerBusinessPlatformDataProvider extends AbstractDataProviderV2<never, RsCustomerBusinessPlatformInfo, never, CustomerBusinessPlatformUpdate> {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/business/{id}/platform');
    }

    public list(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public add(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public remove(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public patch(): Promise<any> {
        return Promise.reject('method is not supported');
    }

    public password(customerId: number, password: string) {
        const url = `middle://rs/customers/${customerId}/password`;
        return this.service.updateRequest(url, 'PUT', { password: password });
    }
}
